import { Data } from 'core/utilities/interfaces';

const IMAGES = {
    // Logos
    mLogo : require('./logoM.png').default,
    manzilLogo : require('./logoManzil.png').default,

    // Icons
    icExpand : require('./icExpand.svg').default,
    icMortgageNew : require('./icMortgageNew.svg').default,
    icMortgagePreapproval : require('./icMortgagePreapproval.svg').default,
    icMortgageSingle : require('./icMortgageSingle.svg').default,
    icMortgageCoapplicant : require('./icMortgageCoapplicant.svg').default,
    icEmail : require('./icEmail.png').default,
    icPadlock : require('./icPadlock.png').default,
    icTrash : require('./trash.svg').default,

    // Graphics
    halalCards : require('./halalCardsNew.png').default,
    plant: require('./plant.png').default,
    dragAndDrop : require('./upload-icon.svg').default,
    selectedDocument : require('./selected-document.png').default,
    sheepWithCoins : require('./sheep-with-coins.svg').default,
    document : require('./doc.svg').default,
    uploadComplete : require('./upload-complete.svg').default,
    moneyPopup: require('./DB Popup.svg').default

} as Data;

export default IMAGES;